
export default {
  data() {
    return {
      macy: null,

      options: [
        {
          name: "title",
          label: this.$t("label.title"),
          type: "text",
        },
        {
          name: "link",
          label: this.$t("label.link"),
          type: "link",
        },
      ],
      optionsInfo: [
        {
          name: "title",
          label: this.$t("label.title"),
          type: "text",
        },
        {
          name: "person",
          label: this.$t("label.person"),
          type: "text",
        },
        {
          name: "contact",
          label: this.$t("label.contact"),
          type: "text",
        },
      ],
    };
  },

  watch: {
    async $isInEditMode() {
      await this.$nextTick();
      this.macy.reInit();
    },
  },

  mounted() {
    this.macy = Macy({
      container: "#masonry-container",
      trueOrder: false,
      margin: 40,
      columns: 3,
      breakAt: {
        1024: 2,
        640: {
          margin: 32,
          columns: 1,
        },
      },
    });
  },
};
